var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry, actionExecutionLocations) {
    pluginRegistry.registerDeploymentAction("Octopus.TransferPackage", function(busy, octopusRepository) {
        return {
            executionLocation: actionExecutionLocations.alwaysOnTarget,
            canChooseRoles: true,
            canHaveChildren: function() { return true; },
            canBeChild: true,
            hasPackages: function(action) { return true; },
            summaryTemplateUrl: "areas/projects/actions/transfer_package/Octopus.TransferPackage_summary.html",

            editTemplateUrl: "areas/projects/actions/transfer_package/Octopus.TransferPackage_edit.html",
            editLink: function ($scope, element) {
                if (!$scope.action.Properties["Octopus.Action.NakedScripting"]) {
                    $scope.action.Properties["Octopus.Action.NakedScripting"] = "False";
                }
            },
            summaryLink: function ($scope, element) {
                var variableExpressionRegex = /^#{(.*?)}$/;
                var matches = $scope.properties["Octopus.Action.Package.PackageId"].match(variableExpressionRegex);
                $scope.packageId = (matches ? $scope.properties[matches[1]] : null) || $scope.properties["Octopus.Action.Package.PackageId"];

                matches = $scope.properties["Octopus.Action.Package.FeedId"].match(variableExpressionRegex);
                $scope.feedId = (matches ? $scope.properties[matches[1]] : null) || $scope.properties["Octopus.Action.Package.FeedId"];
                return octopusRepository.Feeds.get($scope.feedId).then(function (feed) {
                    $scope.feedName = feed.Name;
                });
            }
        };
    });
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/transfer_package/Octopus.TransferPackage.js
// module id = 505
// module chunks = 1